<script>
	import {onMount} from 'svelte'
  	import {fade} from 'svelte/transition'
	import Android from './Android/A2hAndroid.svelte'
	import Apple from './iOS/A2hApple.svelte'
	

	import {getLang} from './common.js'

	let ready = false;
	let lang = "en";
	let showModal = false;
	const nav = navigator;

	console.log(nav);
	const iDevice = (/iphone|ipod|ipad/gi).test(nav.userAgent);
	const iPadOs = nav.maxTouchPoints && nav.maxTouchPoints > 2 && /MacIntel/.test(nav.platform);


 	let labels ={"about":"About","by":"By","version":"Version","description":"Description","youmaylike":"You May Also Like","createapp":"Create Your Own App","ios":{"information":"Information","category":"Category","updated":"Updated","touch":"Touch","or":"or","andthen":"and then","addtohome":"Add To Home","open":"OPEN IN SAFARI","install":"GET","step1":"Step 1","step2":"Step 2","step3":"Step 3","trust":"TRUST","a2htxt":"Add to Home Screen","compat":"Compatibility","requires":"Requires iOS 10.3 and Later","creator":"Creator"},"android":{"apps":"Apps","install":"Install","installnow":"Install Now","instructions":"Follow instructions Below","instructions1":"If needed pull down page to get address bar","instructions2":"Touch button","instructions3":"on the right (top or bottom)","instructions4":"Select 'Add shortcut to home screen'","instructions5":"or","instructions6":"Touch the Android options button","instructions7":"Select Add to home screen ","installlater":"Install Later","openchrome":"Open in Chrome","about":"About this App"}}
 
	const userapp = {
		appid:appId,
		files:files,
		title:appDisplayName,
		user:iGenApp[0].by,
		desc :iGenApp[0].desc,
		cat:iGenApp[0].cat,
		updated:iGenApp[0].created,
		version:userAppVersion,
		status:AppStatusId,
		colors:userColors,
		url:appURL
	}

	onMount(()=>{
		console.log(userapp)
		console.log(iDevice);
		lang = getLang(nav.languages ? nav.languages[0] : nav.language || nav.userLanguage);	
		console.log(lang);
		getLabels();
	})


function getLabels(){
  if(lang !="en"){
    fetch('/localize/add2home-'+ lang +'.json')
    .then((res)=>{
      return res.json()
    })
    .then((json)=>{
      console.log(json);
      labels = json;
      ready = true;
    })
    .catch(function(err){
      console.log(err);
    })
  }else{
    ready = true;
  }
}
</script>

<main>

{#if ready}
	<div class="a2h-container">
		{#if iDevice || iPadOs}
			<Apple {userapp} {lang} {labels} {iPadOs}  />
		{:else}
			<Android {userapp} {lang} {labels}  />
		{/if}
		
	</div>
{/if}




</main>

<style>
	
	
	main {
		text-align: center;
		min-width: 100%;
		min-height: 100%;
		margin: 0 auto;
		padding:0;
		overflow: hidden;
	
	}

	
    .a2h-container {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        background-clip: border-box;
        overflow-x: hidden;
		text-align: left;
    }

	main :global(.share-button) {
        cursor: pointer;
	}
	:global(#iconimg){
		opacity:0;
    	transition: opacity .25s ease-in-out;
	}

	:global(#iconimg.iconLoaded){
		opacity: 1;
	}
:global(.animated) {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

:global(.fadeInUp) {
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

@keyframes fadeInUp {
	from {
		opacity: 0;
		-webkit-transform: translate3d(0, 100%, 0);
		transform: translate3d(0, 100%, 0);
	}

	to {
		opacity: 1;
		-webkit-transform: none;
		transform: none;
	}
}

</style>